<app-recipe-card-finder [focusedAsDefault]="false" />
